import PropTypes from "prop-types";
import React from "react";
import { Row, Col, Button, FormControl } from "react-bootstrap";

import ModalWrapper from "./ModalWrapper";

const Enums = window.Enums;

export default class CategoryEditModal extends React.Component
{
	constructor(props)
	{
		super(props);

		this.state = { category: props.category };
		this.handleClose = this.handleClose.bind(this);
		this.handleSave = this.handleSave.bind(this);
		this.handleCategoryNameChange = this.handleCategoryNameChange.bind(this);
		this.handleCategoryTypeChange = this.handleCategoryTypeChange.bind(this);
	}

	handleSave()
	{
		this.props.onSave(this.state.category);
		this.handleClose();
	}

	handleClose()
	{
		this.props.onClose();
	}

	handleCategoryNameChange(event)
	{
		const category = this.state.category;
		category.name = event.target.value;

		this.setState({ category });
	}

	handleCategoryTypeChange(event)
	{
		const category = this.state.category;
		category.type = +event.target.value;

		this.setState({ category });
	}

	render()
	{
		const category = this.state.category;

		const footerElements = [
			<Button key={0} onClick={this.handleSave}>Save</Button>,
			<Button key={1} onClick={this.handleClose}>Close</Button>
		];

		return (
			<ModalWrapper
				title={"Category Edit"}
				modalClassName={"budget-audit-modal"}
				footerElements={footerElements}
			>
				<div>
					<Row>
						<Col xs={6}>
							<label>Name:</label>
						</Col>
						<Col xs={6}>
							<FormControl
								type="text"
								placeholder="Name"
								className="mousetrap-mod"
								value={category.name || ""}
								onChange={this.handleCategoryNameChange}
								autoFocus={true}
							/>
						</Col>
					</Row>
					<Row>
						<Col xs={6}>
							<label>Type:</label>
						</Col>
						<Col xs={6}>
							<FormControl
								componentClass="select"
								className="mousetrap-mod"
								placeholder="Category Type"
								onChange={this.handleCategoryTypeChange}
								value={category.type || 0}
							>
								{Object.keys(Enums.categoryType).map(categoryType => {
									let typeName = categoryType[0].toUpperCase() + categoryType.substring(1);
									if (typeName === "Unspecified")
									{
										typeName = "";
									}
									const typeId = Enums.categoryType[categoryType];

									return (
										<option key={typeId} value={typeId}>{typeName}</option>
									);
								})}
							</FormControl>
						</Col>
					</Row>
				</div>
			</ModalWrapper>
		);
	}
}

CategoryEditModal.propTypes = {
	onClose: PropTypes.func,
	onSave: PropTypes.func,
	category: PropTypes.shape({
		id: PropTypes.number,
		name: PropTypes.string,
		type: PropTypes.number // See Enums.categoryType
	})
};



// WEBPACK FOOTER //
// ./Components/components/CategoryEditModal.jsx